module.exports = __webpack_public_path__ + "img/walleat_thumbnail_white.5aae00ad.svg";